<template>
  <button
    :class="iconName"
    tabindex="0"
    :aria-label="title"
    :title="title"
    @click.stop="onClick"
    @keyup.enter="onClick"
  />
  <AddToWishlistDrawer
    v-if="isBcom && productId"
    id="wishlistDrawer"
    :product-id="productId"
    @wishlist-drawer-close="onClose"
    @product-is-added="onAddingToWishlist"
  >
    <template #step-select="slotProps">
      <div v-if="slotProps?.product?.id">
        <component
          :is="productThumbnail"
          :product="slotProps?.product"
          :show-wish-list-btn-on-image="false"
          :is-large-card="true"
          :hide-review-text-and-rating="true"
          :use-dropdown-for-sizes="true"
          :image-aspect-ratio="1"
          click-action="disabled"
          review-link="#"
          :url-template="slotProps?.urltemplate"
          @updateUpcId="slotProps?.updateUpcId"
        />
      </div>
    </template>
  </AddToWishlistDrawer>
</template>

<script>
import Toast from '@atomic-ui/toast';
import {
  defineAsyncComponent, markRaw,
  defineComponent, computed, watch, ref,
} from 'vue';
import { AddToWishlistDrawer } from '@common-vue/add-to-wishlist';
import { useWishlistManager } from '../../composables/useWishlist';
import isBcom from '../../utils/isBcom';

export default defineComponent({
  name: 'WishListIcon',
  components: {
    AddToWishlistDrawer,
    ProductThumbnail: () => import('../ProductThumbnail'),
  },
  props: {
    id: {
      type: Number,
      require: true,
      default: null,
    },
  },
  emits: ['wishListIconClicked'],
  setup(props, { emit }) {
    const { isInWishlist, xapiRespMsg, onClick: click } = useWishlistManager(props.id);
    const productId = ref(undefined);

    const onClick = () => {
      if (!isInWishlist.value) {
        productId.value = props.id;
      } else {
        productId.value = undefined;
      }
      setTimeout(click, 0);

      emit('wishListIconClicked', { isInWishlist: isInWishlist.value });
    };

    const onClose = () => {
      productId.value = undefined;
    };

    const onAddingToWishlist = () => {
      isInWishlist.value = true;
    };

    const iconName = computed(() => (isInWishlist.value ? 'wish-list-added' : 'wish-list-removed'));
    const title = computed(() => (isInWishlist.value ? 'Remove from wishlist' : 'Add to default list'));

    watch(xapiRespMsg, (currentValue) => {
      if (currentValue) {
        Toast({
          message: currentValue,
          toastContainerId: `product-thumbnail-${props.id}`,
          placement: 'center',
          duration: 2000,
        });
        xapiRespMsg.value = '';
      }
    });

    return {
      title,
      onClick,
      onClose,
      onAddingToWishlist,
      iconName,
      productId,
      isBcom,
    };
  },
  data() {
    return { productThumbnail: null };
  },
  async mounted() {
    this.productThumbnail = markRaw(defineAsyncComponent(() => import(/* webpackChunkName: "pros-wgl" */ '../ProductThumbnail')));
  },
});
</script>

<style lang="scss" scoped brand="mcom">
@import '@csgIcons/heart-red';
@import '@csgIcons/heart-white-light-border';

.wish-list-added {
  @extend .heart-red;
}

.wish-list-removed {
  @extend .heart-white-light-border
}
</style>

<style lang="scss" scoped brand="bcom">
@import '@csgIcons/heart-pink-filled';
@import '@csgIcons/heart-white-filled';

.wish-list-added {
  @extend .heart-pink-filled;
}

.wish-list-removed {
  @extend .heart-white-filled;
}
</style>
